import { render, staticRenderFns } from "./AddIhaIssue.vue?vue&type=template&id=82157028&scoped=true&"
import script from "./AddIhaIssue.vue?vue&type=script&lang=js&"
export * from "./AddIhaIssue.vue?vue&type=script&lang=js&"
import style0 from "./AddIhaIssue.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddIhaIssue.vue?vue&type=style&index=1&id=82157028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82157028",
  null
  
)

export default component.exports